
import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';


export function GetPCReceiveManageList(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/GetPCReceiveManageList`, params);
}

export function GetTWDeliveryBoxInfoList(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/GetTWDeliveryBoxInfoList`, params);
}

export function GetReceiveBoxInfo(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/GetReceiveBoxInfo`, params);
}


export function GetSkuSignInfoList(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/GetSkuSignInfoList`, params);
}

export const Commonlog = params => {
    return axios.get(`${BaseApiUrl}/ReceiveManage/PCBusinessLogServices`, { params: params });
};


export const PCReceiveManageExport = `${BaseApiUrl}/ReceiveManage/PCReceiveManageExport`;


export const PCReceiveManageExportDetail = `${BaseApiUrl}/ReceiveManage/PCReceiveManageExportDetail`;